<template>
  <div>
    <div class="main-wrap">
      <div id="main-content">
        <div class="wrapper">
          <!--面包屑-->
          <jm-crumbs/>
          <!--查询条件-->
          <div class="basic-padding">
            <span class="form-tit">学校编号：</span>
            <el-input
              v-model="searchData.sh_id"
              class="jm-input135"
              type="text" clearable/>
            <span class="form-tit">学校名称：</span>
            <el-input
              v-model="searchData.sh_name"
              class="jm-input220"
              type="text" clearable/>
            <span class="form-tit" v-if="false">所属国家：</span>
            <el-select
              v-if="false"
              v-model="searchData.sh_country"
              placeholder="请选择" clearable>
              <el-option
                v-for="item in selectData.sh_country"
                :key="item.id"
                :label="item.value"
                :value="item.id"/>
            </el-select>
            &emsp;<el-button
              @click="doRefresh = true"
              type="primary" icon="el-icon-search">查询
            </el-button>
          </div>
          <!--结果列表-->
          <div class="basic-padding">
            <jm-tableList
              class="process-botton"
              url="/index/sales_tools/jpLanguageList"
              :search-data="searchData"
              :refresh.sync="doRefresh"
            >
              <el-table-column
                slot="lastColumn"
                label="操作"
                width="250">
                <template slot-scope="scope">
                  <el-button
                    size="mini"
                    type="primary" icon="el-icon-circle-plus" @click="addPk(scope.row)">添加对比
                  </el-button>
                </template>
              </el-table-column>
            </jm-tableList>
          </div>
          <div class="basic-padding">
            <h2>对比列表</h2>
            <br>
            <el-row :gutter="12" style="background: #fff;padding: 20px">
              <el-col :span="4" v-for="item in pkData" :key="item.sh_id">
                <el-card >
                  {{ item.sh_name_cn }}<br>
                  <el-button type="text" icon="el-icon-delete" @click="delPk(item.sh_id)">删除</el-button>
                </el-card>
              </el-col>

            </el-row>
            <br>
            <el-button
              size=""
              type="primary" icon="el-icon-save" @click="savePk">保存对比数据
            </el-button>
          </div>
          <div class="basic-padding">
            <img :src="src" class="qrcode-img" v-show="src">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import crumbs from '@/components/tool/crumbs';
import tableList from '@/components/data/tableList.vue';
import { jmDictSelect } from '@/components/tool';

export default {
  data() {
    return {
      searchData: {
        sh_id: '',
        sh_name: '',
        sh_country: '',
        sh_mg_id: 238,
        crm_id: 0,
      },
      selectData: {},
      doRefresh: false,
      crm_id: 0,
      pk_id: 0,
      pkData: [],
      src: '',
    };
  },
  mounted() {
    this.crm_id = this.$route.params.id;
    this.searchData.crm_id = this.$route.params.id;
    this.searchDs();
    this.searchPk();
    // this.getQrCode();
  },
  methods: {
    searchDs() {
      this.$http._post({
        url: '/index/sales_tools/searchDs',
      }).then((data) => {
        // console.log(data);
        this.selectData = data.data;
      });
    },
    searchPk() {
      this.$http._post({
        url: '/index/sales_tools/getPkData',
        data: { crm_id: this.crm_id },
      }).then((data) => {
        // console.log(data);
        this.pkData = data.data.pk_data || [];
        this.pk_id = data.data.pk_id || 0;
        if (this.pk_id) {
          this.getQrCode();
        }
      });
    },
    getQrCode() {
      this.$http._post({
        url: '/index/sales_tools/makeQrCode',
        data: { crm_id: this.crm_id },
      }).then((data) => {
        // console.log(data);
        this.src = data;
      });
    },
    addPk(row) {
      // 学校重复添加判断
      if (this.hasPk(row)) {
        this.$message.error('学校已经添加，请勿重复添加！');
        return;
      }
      // 学校列表最大值判断
      if (this.pkData.length >= 5) {
        this.$message.error('最多可添加5所学校！');
        return;
      }
      this.pkData.push(row);
    },
    delPk(id) {
      for (let i = 0; i < this.pkData.length; i++) {
        if (this.pkData[i].sh_id == id) {
          this.pkData.splice(i, 1);
          i--;
        }
      }
    },
    hasPk(row) {
      let flag = false;
      for (let i = 0; i < this.pkData.length; i++) {
        if (this.pkData[i].sh_id == row.sh_id) {
          flag = true;
          break;
        }
      }
      return flag;
    },
    savePk() {
      // 学校列表最小值判断
      if (this.pkData.length < 2) {
        this.$message.error('至少选择两个学校，才可使用对比功能！');
        return;
      }
      this.$http._post({
        url: '/index/sales_tools/savePk',
        data: { crm_id: this.crm_id, pk_id: this.pk_id, pk_data: this.pkData },
      }).then((data) => {
        console.log(data);
        this.$message.success('保存成功');
      });
    }
  },
  components: {
    'jm-crumbs': crumbs,
    'jm-tableList': tableList,
    jmDictSelect
  },
  wacth: {}
};
</script>
<style scoped>
  .form-tit {
    margin-left: 10px;
  }

  .basic-padding {
    clear: both;
    padding: 15px 0;
  }
</style>
<style>
</style>
